import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReviewModal } from '../../../components/shared/ReviewModal/ReviewModal';
import { useAuth } from '../../../context/AuthContext';

export const CardDetailsHost = ({event}) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);

  const handleViewProfile = () => {
    if (event?.organizerId?._id) {
      navigate(`/organizer/${event.organizerId._id}`);
    }
  };

  const handleReportEvent = () => {
    if (!user?.result?._id) {
      navigate('/login');

      return;
    }
    setIsReviewModalOpen(true);
  };

  const handleReviewSuccess = (data) => {
    console.log('Review submitted successfully:', data);
    // You can add a toast notification here
  };

  const handleReviewError = (error) => {
    console.error('Review submission failed:', error);
  };

  return (
    <>
      <div data-w-id="4db98acf-151e-b8b5-28c8-d03c9b1db100" style={{ opacity: 1 ,marginTop:30}} className="site_review-details">
        <div className="review_details-left-item">
          <div className="review_details-flex-item">
            <div className="review-five-user"><img loading="lazy" src={event?.organizerId?.profile_pic} alt="" className="listing-page-user-dp" /></div>
            <div className="review_details-content">
              <div className="margin-bottom margin-xxsmall">
                <h6 className="heading-6">Hosted by {event?.organizerId?.full_name}</h6>
              </div>
              <div className="margin-bottom">
                <div className="date-text">{event?.organizerId?.gender || 'NA'}, {event?.organizerId?.age || 'NA'} Years Old</div>
              </div>
            </div>
          </div>
            
           
            <p className="paragraph-3">Looking forward to hosting you! I travelled the world with friends and also on my own, so I know how to start a a good conversation to stay. </p>
          <div className="margin-bottom margin-small view-profile-btn">
            <button onClick={handleViewProfile} className="button-4 w-button" style={{ cursor: 'pointer' }}>View Profile</button>
          </div>
        </div>
        <div id="w-node-_4db98acf-151e-b8b5-28c8-d03c9b1db11f-d3b03550">
          <h6 className="heading-6">Support</h6>
          <div className="protection-div-flex magrin-top-1rem">
            <div className="text-block-12">To protect your payment, never transfer<br />money or communicate outside of the<br />Hobi website or app.</div>
          </div>
          <div className="report-div magrin-top-1rem">
            <button onClick={handleReportEvent} className="report-btn w-button" style={{ cursor: 'pointer' }}>Report Event</button>
          </div>
        </div>
      </div>

      {/* Review Modal */}
      <ReviewModal
        isOpen={isReviewModalOpen}
        onClose={() => setIsReviewModalOpen(false)}
        userId={user?.result?._id}
        eventId={event?._id}
        eventName={event?.title}
        onSubmitSuccess={handleReviewSuccess}
        onSubmitError={handleReviewError}
      />
    </>
  );
};
